import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, useSeo } from "@/lib/api";
import Breadcrumbs from "@/components/Breadcrumbs";
import { Calendar, User } from "lucide-react";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => { api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(console.error); }, [slug]);

  useSeo(
    post ? `${post.title} — SharePromos` : "Article",
    post?.excerpt || "",
    {
      keywords: post ? [...(post.tags || []), "savings guide", "coupon blog", "money tips"].join(", ") : undefined,
      image: post?.cover_image,
      type: "article",
    }
  );

  if (!post) return <div className="max-w-3xl mx-auto px-6 py-20">Loading…</div>;

  return (
    <article className="max-w-3xl mx-auto px-6 lg:px-8 py-16" data-testid="blog-post-page">
      <Breadcrumbs items={[
        { label: "Blog", to: "/blog" },
        { label: post.title.length > 40 ? post.title.slice(0, 40) + "…" : post.title },
      ]} />
      <p className="overline mb-4 flex items-center gap-2">
        <Calendar className="w-3 h-3" />
        {new Date(post.published_at).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}
      </p>
      <h1 className="font-display text-4xl md:text-6xl tracking-tighter uppercase leading-[0.95] mb-6">{post.title}</h1>
      <p className="text-lg text-slate-600 leading-relaxed mb-8 font-medium">{post.excerpt}</p>
      <div className="flex items-center gap-2 text-sm text-slate-500 mb-10 pb-8 border-b border-slate-200">
        <User className="w-4 h-4" /> {post.author}
        {post.tags?.length > 0 && (
          <span className="ml-4 flex gap-2">
            {post.tags.map((t) => (
              <span key={t} className="px-2 py-0.5 border border-slate-300 rounded-sm text-xs">{t}</span>
            ))}
          </span>
        )}
      </div>
      {post.cover_image && (
        <img src={post.cover_image} alt={`Cover image for ${post.title}`} className="w-full aspect-[16/9] object-cover mb-10 rounded-sm" />
      )}
      <div className="prose prose-slate max-w-none text-base leading-relaxed text-slate-700 whitespace-pre-line">
        {post.content}
      </div>
    </article>
  );
}
